import { useTranslation } from "react-i18next";
import data from "../../../data";
import { Col, Row } from "react-bootstrap";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import css from "./VKIVIU.module.css";

function BenefitVKIVIU() {
  const { t } = useTranslation();

  return (
    <>
      <div className="tkdn-container-definition">
        <div className="tkdn-section-header">
          <div className="border-title-vpti" />
          <h1 className="tkdn-section-title">{t("vkiviu_benefit.title")}</h1>
        </div>
        <Row className="container-about-img">
          <Col key={1} className={css.cardContainer}>
            <h2 className="lvv-subtitle">{t(`vkiviu_benefit.VKI.title`)}</h2>
            <div className={css.typeContainer}>
              {Array.from(data.vkiviu_benefit.VKI.benefit, (benefit, i) => {
                return (
                  <span className={css.typeList}>
                    <FontAwesomeIcon
                      icon={faCheck}
                      style={{ color: "rgb(53, 157, 0)" }}
                    />
                    <p>{t(`vkiviu_benefit.VKI.benefit.${i}`)}</p>
                  </span>
                );
              })}
            </div>
          </Col>
          <Col key={2} className={css.cardContainer}>
            <h2 className="lvv-subtitle">{t(`vkiviu_benefit.VIU.title`)}</h2>
            <div className={css.typeContainer}>
              {Array.from(data.vkiviu_benefit.VIU.benefit, (benefit, i) => {
                return (
                  <span className={css.typeList}>
                    <FontAwesomeIcon
                      icon={faCheck}
                      style={{ color: "rgb(53, 157, 0)" }}
                    />
                    <p>{t(`vkiviu_benefit.VIU.benefit.${i}`)}</p>
                  </span>
                );
              })}
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}
export default BenefitVKIVIU;
